
import { i18nText } from '@/locales';
export class ServiceCategoryForm {
    id?:                        number;
    name:                       string;
    online_appointment_name:    string;
    nomenclature_id:            number | null;
    salon_id:                   number | null;

    constructor() {
        this.name = '';
        this.online_appointment_name = '';
        this.nomenclature_id = null;
        this.salon_id = null;
    }
}
export const FormRules = {
    name: [
        { required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: "change" },
    ],
    //online_appointment_name: [{ required: true, message: "Пожалуйста укажите описание", trigger: "change" }],


};
